import { useSyncExternalStore } from 'react';

// Active checkout promo code, read by every payment form when building its payload.
let current = '';
const listeners = new Set();

export const setActivePromo = (code) => {
  const next = code || '';
  if (next === current) return;
  current = next;
  listeners.forEach((l) => l());
};

export const getActivePromo = () => current;

const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export const useActivePromo = () => useSyncExternalStore(subscribe, getActivePromo);
